// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';
export const swiperInit = () =>{
    const swiper = new Swiper('.swiper', {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      });

      if(checkIfEnoughSlides(document.querySelector(".swiper2"))){
        const swiper2 = new Swiper('.swiper2', {
          loop: false,
          slidesPerView: 1,
          breakpoints: {
            576: {
              slidesPerView:2.2,
            },
            992: {
                slidesPerView: 3,
                
            },
           
        }
        });
      }
     
    const swiper3 = new Swiper('.swiper3', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween:50,
        autoplay: {

          delay:1000
        },
        breakpoints: {
          // when window width is <= 499px
          768: {
            spaceBetween: 85
        },
          1366: {
            spaceBetween: 132
          },
         
      }
      });
}
let checkIfEnoughSlides = (container) => {
  if(container){
    let count = container.querySelectorAll(".swiper-slide");
    if(count) {
      return count.length >= 3 ? true : false; 
  
    }
    else {
      return false;
    }
  }
 
}